import DefaultModal from "../../common/components/modal/default-modal/DefaultModal";
import { types } from "../../common/components/helpers/eventEmitter";
import { Container } from "@mui/material";
import React, { ChangeEvent, useEffect, useState } from "react";
import ModalFooter from "../../common/components/modal/modal-footer/ModalFooter";
import { modalTypes } from "../../common/constants/field-constants";
import ModalHeader from "../../common/components/modal/modal-header/ModalHeader";
import styles from "./GlobalSearch.styles";
import FilterMenu from "./components/FilterMenu";
import SearchBlock from "./components/SearchBlock";
import {
  editSettingsRequest,
  receiveSettingsRequest,
} from "./actions/settings";
import { connect, useDispatch } from "react-redux";
import { selectSearch } from "./selectors";
import AlertService from '../../common/services/notification.service';
import UserService from '../../common/services/user.service';
import type { RootState } from '../../reducers';

const initialSettingsState = {
  search_limits: {
    objectsLimit: 5,
    entitiesLimit: 5,
  },
  // objectsLimit: 5,
  // entitiesLimit: 5,
  queryCity: "",
  queryCitiesGroup: [],
  area_filters: {
    city: true,
    cities: false,
  },
  search_type: {
    entity: true,
    object: true,
  },
  entity_search_type: {
    entity_name: true,
    entity_phone_number: true,
    entity_kadaster_id: false,
  },
  entity_type: {
    person: true,
    company: false,
  },
  entity_role: {
    owner: false,
    non_owner: false,
    contact: false,
    manager: false,
    all: true,
  },
  object_search_type: {
    object_street_name: true,
    object_kadaster_id: false,
  },
  object_plot_params: {
    object_plot_G0: true,
    object_plot_A1: false,
  },
};

const GlobalSearchModal = (props: any) => {
  const dispatch = useDispatch();
  const { getSettings } = props;
  const [userSearchSettings, setUserSearchSettings] =
    useState(initialSettingsState);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [currentUserId, setUserId] = useState(null);

  const handleOpen = (userId: any) => {
    if (userId) {
      setUserId(userId);
    }
    if (!UserService.token) return;
    dispatch(receiveSettingsRequest());
  };

  const handleClose = () => {
    setUserSearchSettings(getSettings);
  };
  // console.log('userSearchSettings', userSearchSettings);
  // useEffect(() => {
  //   dispatch(receiveSettingsRequest());
  // }, [dispatch]);

  useEffect(() => {
    // getSettings && setUserSearchSettings(getSettings);
    if (getSettings && Object.keys(getSettings).length !== 0) {
      return setUserSearchSettings(getSettings);
    } else {
      if (!UserService.token) return;
      // dispatch(receiveSettingsRequest());
      return setUserSearchSettings(initialSettingsState);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, getSettings]);

  const handleChecked = (
    block: any,
    field: string,
    event: ChangeEvent<HTMLInputElement>
  ) => {
    if (block === "area_filters") {
      if (field === "city") {
        return setUserSearchSettings({
          ...userSearchSettings,
          [block]: {
            [field]: event.target.checked,
            cities: !event.target.checked,
          },
        });
      } else {
        return setUserSearchSettings({
          ...userSearchSettings,
          [block]: {
            [field]: event.target.checked,
            city: !event.target.checked,
          },
        });
      }
    }
    if (block === "search_type") {
      const checked = event.target.checked;
      return setUserSearchSettings((prev) => {
          const settings = {...prev}
          settings.search_type = {
            ...prev.search_type,
            [field]: checked,
          }
          if (!settings.search_type.entity && !settings.search_type.object) {
            if (field === "entity") {
              settings.search_type.object = true;
            } if (field === "object") {
              settings.search_type.entity = true;
            }
          }
          return settings;
      });
    }
    if (block === "entity_search_type") {
      if (field === "entity_kadaster_id") {
        return setUserSearchSettings({
          ...userSearchSettings,
          [block]: {
            entity_name: !event.target.checked,
            entity_phone_number: !event.target.checked,
            [field]: event.target.checked,
          },
        });
      } else if (field === "entity_name") {
        return setUserSearchSettings({
          ...userSearchSettings,
          [block]: {
            [field]: event.target.checked,
            entity_phone_number: !event.target.checked,
            entity_kadaster_id: !event.target.checked,
          },
        });
      } else {
        return setUserSearchSettings({
          ...userSearchSettings,
          [block]: {
            [field]: event.target.checked,
            entity_name: !event.target.checked,
            entity_kadaster_id: !event.target.checked,
          },
        });
      }
    }
    if (block === "entity_type") {
      if (field === "person") {
        return setUserSearchSettings({
          ...userSearchSettings,
          [block]: {
            [field]: event.target.checked,
            company: !event.target.checked,
          },
        });
      } else {
        return setUserSearchSettings({
          ...userSearchSettings,
          entity_role: {
            all: true,
            owner: false,
            non_owner: false,
            contact: false,
            manager: false,
          },
          [block]: {
            [field]: event.target.checked,
            person: !event.target.checked,
          },
        });
      }
    }
    if (block === "entity_role") {
      const current = {...userSearchSettings.entity_role};
      const checked = event.target.checked;

      if (field === "all") {
        return setUserSearchSettings({
          ...userSearchSettings,
          [block]: {
            [field]: checked,
            owner: checked ? !checked : !checked,
            non_owner: checked ? !checked : checked,
            contact: checked ? !checked : checked,
            manager: checked ? !checked : checked,
          },
        });
      }
      const allChecked = ["owner", "non_owner", "contact", "manager"].every(key => key === field ? checked : current[key as keyof typeof current]);

      if (allChecked) {
        return setUserSearchSettings(prev => ({
          ...prev,
          [block]: {
            all: true,
            owner: false,
            non_owner: false,
            contact: false,
            manager: false,
          },
        }));
      } else {
        return setUserSearchSettings({
          ...userSearchSettings,
          [block]: {
            ...userSearchSettings[block],
            [field]: checked,
            all: false,
          },
        });
      }
    }
    if (block === "object_search_type") {
      if (field === "object_kadaster_id") {
        return setUserSearchSettings({
          ...userSearchSettings,
          [block]: {
            object_street_name: !event.target.checked,
            [field]: event.target.checked,
          },
        });
      } else {
        return setUserSearchSettings({
          ...userSearchSettings,
          [block]: {
            [field]: event.target.checked,
            object_kadaster_id: false,
          },
        });
      }
    }

    return setUserSearchSettings({
      ...userSearchSettings,
      [block]: {
        ...userSearchSettings[block],
        [field]: event.target.checked,
      },
    });
  };

  const handleChangeCity = (type: string, valueChange: any) => {
    if (type === "queryCitiesGroup") {
      const convertedValue = valueChange?.map(({ city }) => city);
      return setUserSearchSettings({
        ...userSearchSettings,
        queryCitiesGroup: convertedValue,
      });
    }
    if (type === "queryCity") {
      const convertedValue = valueChange !== null ? valueChange?.city : "";
      return setUserSearchSettings({
        ...userSearchSettings,
        queryCity: convertedValue,
      });
    }
  };

  const handleBlurLimit = (
    block: any,
    field: string,
    event: ChangeEvent<HTMLInputElement>
  ) => {

    if (block === "search_limits") {
      let value = event.target.value;
       if (value === "") {
         if (field === "objectsLimit") {

           return setUserSearchSettings(prev => ({
             ...prev,
             // ...userSearchSettings,
             [block]: {
               // ...userSearchSettings[block],
               ...prev[block],
               [field]: getSettings && Object.keys(getSettings).length !== 0
                 ? getSettings.search_limits.objectsLimit
                 : initialSettingsState.search_limits.objectsLimit,
             },
           }));
         }
          if (field === "entitiesLimit") {
             return setUserSearchSettings(prev => ({
               ...prev,
               // ...userSearchSettings,
               [block]: {
                 // ...userSearchSettings[block],
                 ...prev[block],
                 [field]: getSettings && Object.keys(getSettings).length !== 0
                   ? getSettings.search_limits.entitiesLimit
                   : initialSettingsState.search_limits.entitiesLimit,
               },
             }));
          }
       }
    }
  }

  const handleChangeLimit = (
    block: any,
    field: string,
    event: ChangeEvent<HTMLInputElement>
  ) => {
    if (block === "search_limits") {
      let val = event.target.value;
      val = val.replace(/^0+(?=\d)/,"");
      const num = Number(val);
      if (val && (num < 1 || num > 50)) {
        AlertService.warning("Please enter a number between 1 and  50");
        return;
      }
      if (field === "objectsLimit") {
        return setUserSearchSettings(prev => ({
          ...prev,
          // ...userSearchSettings,
          [block]: {
            // ...userSearchSettings[block],
            ...prev[block],
            [field]: val,
          },
        }));
      }
      if (field === "entitiesLimit") {
        return setUserSearchSettings(prev => ({
          ...prev,
          // ...userSearchSettings,
          [block]: {
            // ...userSearchSettings[block],
            ...prev[block],
            [field]: val,
          },
        }));
      }
    }
  };
  const handleUpdateSettings = () => {
    dispatch(editSettingsRequest(userSearchSettings));
  };

  return (
    <>
      <DefaultModal
        onOpen={handleOpen}
        onClose={handleClose}
        nameEvent={types.openGlobalSearchModal}
        modalType="search"
      >
        {({ closeModal }) => (
          <>
            <ModalHeader title={"SEARCH"} />
            <Container sx={styles.searchContainer}>
              <FilterMenu
                settings={userSearchSettings}
                handleChecked={handleChecked}
                handleUpdateSettings={handleUpdateSettings}
                changeCities={handleChangeCity}
                changeLimit={handleChangeLimit}
                handleBlurLimit={handleBlurLimit}
              />
              <SearchBlock
                filters={userSearchSettings}
                closeModal={closeModal}
              />
            </Container>
            <ModalFooter closeModal={closeModal} type={modalTypes.INFO} />
          </>
        )}
      </DefaultModal>
    </>
  );
};

function mapStateToProps(state: RootState) {
  //@ts-ignore
  const { getSettings } = selectSearch(state);
  return { getSettings };
}

export default connect(mapStateToProps)(GlobalSearchModal);
